import React from 'react'
import UserWrapper from '../../../../layout/userwrapper/UserWrapper'
import { Avatar, Button, Input, InputAdornment, InputLabel, List, ListItem, MenuItem, Paper, Select, Stack, TextField } from '@mui/material'
import styles from '../../../../styles/pages/user/content-buyer-myaccount.module.scss'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import EditIcon from '../../../../ui/Icons/EditIcon';
import DollarIcon from '../../../../public/assets/icons/DollarIcon';
import AlertIcon from '../../../../ui/Icons/Alert';
import noImg from '../../../../public/assets/images/no-image.svg'
import logoTipalti from '../../../../public/assets/images/logo-tipalti.png'
import LoginIcon from '../../../../public/assets/icons/LoginIcon';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>
                    {children}
                </>
            )}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function ContentBuyerMyAccount() {

    const [value, setValue] = React.useState(0);
    const [country, setCountry] = React.useState("");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const countryhandleChange = (event) => {
        setCountry(event.target.value);
    };


    return (
        <UserWrapper headerPurchaseBtn={true} footerChatBtn={true}>
            <Paper elevation={0} className={styles.pageMyaccount}>
                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'} className={styles.accountRow}>
                    <Box className={styles.accountTabSec}>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className={styles.tabsButtonGroup}>
                            <Tab label="Personal Details" {...a11yProps(0)} />
                            <Tab label="Account Settings" {...a11yProps(1)} />
                        </Tabs>
                        <Box className={styles.tabContent}>
                            <CustomTabPanel value={value} index={0}>
                                <Box className={styles.tabPersonalcontent}>
                                    <PerfectScrollbar className={styles.accountTabscroll}>
                                        <Box className={styles.formgroupAcc}>
                                            <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                <Typography variant='caption'>Full name</Typography>
                                                <Button><EditIcon /></Button>
                                            </Stack>
                                            <Box className={styles.groupWrap}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                    <Box className={`${styles.formInput_firstname} ${styles.inputCol}`}>
                                                        <InputLabel>First Name</InputLabel>
                                                        <TextField placeholder="Avraam" />
                                                    </Box>
                                                    <Box className={`${styles.formInput_lastname} ${styles.inputCol}`}>
                                                        <InputLabel>Last Name</InputLabel>
                                                        <TextField placeholder="Petridis" />
                                                    </Box>
                                                </Stack>
                                            </Box>
                                        </Box>
                                        <Box className={styles.formgroupAcc}>
                                            <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                <Typography variant='caption'>Physical Address</Typography>
                                                <Button><EditIcon /></Button>
                                            </Stack>
                                            <Box className={styles.groupWrap}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                    <Box className={`${styles.formInput_address} ${styles.inputCol}`}>
                                                        <InputLabel>Address</InputLabel>
                                                        <TextField />
                                                    </Box>
                                                    <Box className={`${styles.formInput_city} ${styles.inputCol}`}>
                                                        <InputLabel>City</InputLabel>
                                                        <TextField />
                                                    </Box>
                                                    <Box className={`${styles.formInput_state} ${styles.inputCol}`}>
                                                        <InputLabel>State</InputLabel>
                                                        <TextField />
                                                    </Box>
                                                    <Box className={`${styles.formInput_zip} ${styles.inputCol}`}>
                                                        <InputLabel>Zip Code</InputLabel>
                                                        <TextField />
                                                    </Box>
                                                    <Box className={`${styles.formInput_country} ${styles.inputCol}`}>
                                                        <InputLabel>Country</InputLabel>
                                                        <Select
                                                            value={country}
                                                            onChange={countryhandleChange}
                                                            displayEmpty
                                                            inputProps={{ "aria-label": "Without label" }}
                                                            MenuProps={{
                                                                PaperProps: {
                                                                    sx: {
                                                                        boxShadow: "0px 0px 4px 1px rgba(0, 0, 0, 0.08)",
                                                                        borderRadius: "7px",
                                                                        marginTop: "5px",

                                                                        "& .MuiMenuItem-root": {
                                                                            padding: 0,
                                                                            fontSize: "11px",
                                                                            fontWeight: "500",
                                                                            color: "#525050",
                                                                            lineHeight: "1",
                                                                            "&:hover": {
                                                                                backgroundColor: "#ffffff",
                                                                                color: "#111ae9",
                                                                            },
                                                                            "&:not(:last-child)": {
                                                                                marginBottom: "10px",
                                                                            },
                                                                            "&:first-child": {
                                                                                display: "none"
                                                                            },
                                                                        },
                                                                        "& .Mui-selected": {
                                                                            background: "#fff !important",
                                                                        },

                                                                        "& .MuiList-root": {
                                                                            padding: "20px 14px",
                                                                            minWidth: "134px",
                                                                        },
                                                                    },
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="">Select country</MenuItem>
                                                            <MenuItem value='asd'>India</MenuItem>
                                                            <MenuItem value='2'>Russia</MenuItem>
                                                            <MenuItem value='1'>United States</MenuItem>
                                                        </Select>
                                                    </Box>
                                                </Stack>
                                            </Box>
                                        </Box>
                                        <Box className={`${styles.formgroupAcc} ${styles.formgroupPhone}`}>
                                            <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                <Typography variant='caption'>Phone Number</Typography>
                                                <Button><EditIcon /></Button>
                                            </Stack>
                                            <Box className={styles.groupWrap}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                    <Box className={`${styles.formInput_phno} ${styles.inputCol}`}>
                                                        <TextField />
                                                    </Box>
                                                </Stack>
                                            </Box>
                                        </Box>
                                        <Box className={styles.formgroupAcc}>
                                            <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                <Typography variant='caption'>Salary</Typography>
                                            </Stack>
                                            <Box className={styles.groupWrap}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                    <Box className={`${styles.formInput_salary} ${styles.inputCol}`}>
                                                        <TextField
                                                            InputProps={{
                                                                startAdornment: <InputAdornment position="start">
                                                                    <DollarIcon />
                                                                </InputAdornment>,
                                                                sx: {
                                                                    paddingLeft: '12px'
                                                                }
                                                            }} />
                                                        <Typography variant='body2' className={styles.warningAlert}><AlertIcon /> You can not update this field.</Typography>
                                                    </Box>
                                                </Stack>
                                            </Box>
                                        </Box>
                                    </PerfectScrollbar>
                                </Box>
                            </CustomTabPanel>
                            <CustomTabPanel value={value} index={1}>
                                <Box className={styles.tabAccountcontent}>
                                    <PerfectScrollbar className={styles.accountTabscroll}>
                                        <Stack direction={'row'} alignItems={'flex-end'} flexWrap={'wrap'} className={styles.accountPfrow}>
                                            <Box className={styles.pfLeftBox}>
                                                <Box className={styles.formgroupAcc}>
                                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                        <Typography variant='caption'>Profile Picture</Typography>
                                                    </Stack>
                                                    <Box className={styles.groupWrap}>
                                                        <Stack direction="row" alignItems="center" flexWrap="wrap" className={styles.profileSec}>
                                                            <Avatar
                                                                alt="Profile Image"
                                                                src={noImg}
                                                                sx={{ width: 97, height: 97 }}
                                                            />
                                                            <List disablePadding>
                                                                <ListItem className={styles.customUploadFile} disablePadding>
                                                                    <input type="file" id="upload" hidden />
                                                                    <label htmlFor="upload">update picture </label>
                                                                </ListItem>
                                                                <ListItem disablePadding>
                                                                    <Button className={styles.removeBtn}>remove it </Button>
                                                                </ListItem>
                                                            </List>
                                                        </Stack>
                                                    </Box>
                                                </Box>
                                                <Box className={`${styles.formgroupAcc} ${styles.formgroupMail}`}>
                                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                        <Typography variant='caption'>Email Address</Typography>
                                                    </Stack>
                                                    <Box className={styles.groupWrap}>
                                                        <Box className={styles.showEmail}>
                                                            <Typography variant="body1">Your email address is{" "}<strong>username@viralsnare.com</strong></Typography>
                                                            <Typography variant="caption"><AlertIcon /> Email address cannot be changed.</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                            <Box className={styles.pfRightBox}>
                                                <Box className={styles.pfRightInner}>
                                                    <Box className={`${styles.formgroupAcc} ${styles.formgroupAccName}`}>
                                                        <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                            <Typography variant='caption'>Account Name</Typography>
                                                            <Button><EditIcon /></Button>
                                                        </Stack>
                                                        <Box className={styles.groupWrap}>
                                                            <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                                <Box className={`${styles.formInput_account} ${styles.inputCol}`}>
                                                                    <TextField />
                                                                </Box>
                                                            </Stack>
                                                        </Box>
                                                    </Box>
                                                    <Box className={`${styles.formgroupAcc} ${styles.formgroupMail} ${styles.formSubmission}`}>
                                                        <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                            <Typography variant='caption'>Submission Page</Typography>
                                                        </Stack>
                                                        <Box className={styles.groupWrap}>
                                                            <Box className={styles.showEmail}>
                                                                <Typography variant="body1">Your submission page URL is{" "}<strong>arseny.viralsnare.com</strong></Typography>
                                                                <Typography variant="caption"><AlertIcon /> Submission page cannot be changed.</Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Stack>
                                        <Box className={styles.accPassword}>
                                            <Box className={styles.formgroupAcc}>
                                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.formLabel}>
                                                    <Typography variant='caption'>Password</Typography>
                                                </Stack>
                                                <Box className={styles.groupWrap}>
                                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                        <Box className={`${styles.formInput_password} ${styles.inputCol}`}>
                                                            <InputLabel>Current password</InputLabel>
                                                            <TextField type='password' />
                                                        </Box>
                                                    </Stack>
                                                </Box>
                                                <Box className={styles.groupWrap}>
                                                    <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.groupRow}>
                                                        <Box className={`${styles.formInput_password} ${styles.inputCol}`}>
                                                            <InputLabel>New password</InputLabel>
                                                            <TextField type='password' />
                                                        </Box>
                                                        <Box className={`${styles.formInput_password} ${styles.inputCol}`}>
                                                            <InputLabel>Confirm new password</InputLabel>
                                                            <TextField type='password' />
                                                        </Box>
                                                    </Stack>
                                                    <Box className={styles.savePassword}>
                                                        <Button>Save Password</Button>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </PerfectScrollbar>
                                </Box>
                            </CustomTabPanel>
                        </Box>
                    </Box>
                    <Box className={styles.accSecRight}>
                        <Box className={styles.rightTipalti}>
                            <figure>
                                <img src={logoTipalti} alt="" />
                            </figure>
                            <Typography variant='body1'>You are eligible to receive payments.</Typography>
                            <Button startIcon={<LoginIcon />}>Login</Button>
                        </Box>
                    </Box>
                </Stack>
            </Paper>
        </UserWrapper>
    )
}
